import { StakeholderType } from '@urbanx/agx-ui-components';

export const SigningOrderOption = {
  NoSigningOrder: 'no-signing-order',
  BuyersFirst: 'buyers-first',
  VendorsFirst: 'vendors-first',
} as const;

export type SigningOrderOption = (typeof SigningOrderOption)[keyof typeof SigningOrderOption];

export const getSigningOrderGroups = (selectedSigningOrder: SigningOrderOption) => {
  if (selectedSigningOrder === SigningOrderOption.NoSigningOrder) {
    return undefined;
  }

  return selectedSigningOrder === SigningOrderOption.VendorsFirst
    ? [StakeholderType.Vendor, StakeholderType.Buyer]
    : [StakeholderType.Buyer, StakeholderType.Vendor];
};

export const getOrderedStakeholders = (
  stakeholders: StakeholderType[],
  signingOrderGroups: StakeholderType[]
) => {
  const groupStakeholders = signingOrderGroups.flatMap((group) => {
    if (group === StakeholderType.Buyer) {
      return [StakeholderType.Buyer];
    }

    if (group === StakeholderType.Vendor) {
      return [StakeholderType.Vendor];
    }

    return [];
  });

  return groupStakeholders.filter((stakeholder) => stakeholders.includes(stakeholder));
};
